import React from 'react';
import { Receipt, LogIn } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface EmptyStateProps {
  variant?: 'default' | 'guest';
  onLogin?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ variant = 'default', onLogin }) => {
  const isGuest = variant === 'guest';
  const { t } = useTranslation('tx');

  return (
    <div className="bg-white rounded-lg shadow-md p-12 flex flex-col items-center justify-center text-center">
      <div className="mb-6">
        <div className="w-32 h-32 md:w-40 md:h-40 mx-auto bg-gray-100 rounded-full flex items-center justify-center">
          <Receipt className="text-gray-400" size={64} />
        </div>
      </div>

      <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-2">
        {t('empty_title')}
      </h3>
      <p className="text-gray-600 max-w-md mb-4">
        {isGuest ? t('empty_guest_msg') : t('empty_user_msg')}
      </p>

      {isGuest && onLogin && (
        <button
          onClick={onLogin}
          className="inline-flex items-center gap-2 px-6 py-2 bg-primary text-white rounded-lg hover:brightness-90 font-medium"
        >
          <LogIn size={16} />
          {t('empty_login')}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
